<template>
  <div id="sticky_sortby_wrapper" class="search-filter-wrapper">
    <div
      :id="!screen.isDesktop ? 'sticky_sortby' : ''"
      :class="{ 'sticky box-shadow': isScroll }"
      class="search-filter"
      :style="`top:${scrollTop}px;`"
      @scroll="stickySortBy"
    >
      <div :class="{ 'pb-0': !status.tag, scrolled: isScroll }" class="tabs search-filter__tabs">
        <div v-if="isScroll" :class="{ 'no-tag': !status.tag }" class="sort-sticky-title">
          <div class="sort-sticky-title__left">
            <!-- :event="isSelected ? '' : 'click'" -->
            <span
              class="sort-sticky-title__name"
              @click="
                isSelected
                  ? resetFilter($event, 'category')
                  : (!listLeftMobile.length ? '' : (showDropDown = !showDropDown), (sortMobile = false))
              "
            >
              {{ title.top }}
              <SvgImg
                v-if="isSelected"
                class="remove"
                name="close-black-icon"
                width="12"
                height="12"
                style="margin: 0 0 -2px 3px"
              />
              <SvgImg
                v-else-if="listLeftMobile.length"
                :name="showDropDown ? 'red-arrow-up' : 'red-arrow-down'"
                width="10"
                height="7"
                style="margin: 0 0 1px 3px"
              />
            </span>
            <ul v-if="showDropDown" class="sort-sticky-title__popup">
              <li @click.prevent="resetFilter(null, 'category')">
                {{ parentList }}
              </li>
              <li v-for="(children, idx) in listLeftMobile" :key="'sort-cat-' + idx" class="parent_name__">
                <span @click="selectedList(children, 1, idx)">{{ children.name }}</span>
                <ul
                  v-if="
                    (children.children && children.children.length) ||
                    (children.sub_categories && children.sub_categories.length)
                  "
                  class="child_name__"
                >
                  <li
                    v-for="(children2, idx2) in children.children || children.sub_categories"
                    :key="'sort-cat-child-' + idx2"
                  >
                    <span @click="selectedList(children2, 2, idx2)">{{ children2.name }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="sort-sticky-title__right" @click="(sortMobile = !sortMobile), (showDropDown = false)">
            <span class="sort-sticky-title__sort-name">
              {{ sortName ? sortName : 'Sort by' }}
              <SvgImg
                :name="sortMobile ? 'red-arrow-up' : 'red-arrow-down'"
                width="10"
                height="7"
                style="margin: 0 0 1px 3px"
              />
            </span>
            <span v-if="sortName && defaultSort !== sortBy" class="sort-reset" @click.stop="resetSort">
              <SvgImg name="close-black-icon" width="12" height="12" style="margin: 0 0 -2px 0" />
            </span>
            <ul v-if="sortMobile" class="modal-sort">
              <li v-for="(item, i) in listSort" :key="`sorts-${i}`" @click.stop="setSelected(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <template v-else>
          <ul v-if="title.top || title.bottom" class="title">
            <li v-if="topTitle" class="title__name">{{ topTitle }}</li>
            <li class="title__count">{{ title.bottom }} Product{{ title.bottom > 1 ? 's' : '' }}</li>
          </ul>
          <div class="right-content" @click="showSort">
            <template v-if="screen.isDesktop">
              <span class="tabs__item__search-filter__text-limit">Sort by</span>
              <select v-model="sortBy" class="form-control tabs__item__search-filter__form-control show-sort">
                <option value="" disabled>-</option>
                <option v-for="(item, i) in listSort" :key="`sorts-list-${i}`" :value="item.url">
                  {{ item.label }}
                </option>
              </select>
            </template>
            <template v-else>
              <SvgImg name="sort-icon" width="18" height="12" />
              <span class="sort-name">{{ sortName ? sortName : 'Sort by' }}</span>
              <span v-if="sortName && defaultSort !== sortBy" class="sort-reset" @click.stop="resetSort">
                <SvgImg name="close-black-icon" width="12" height="12" />
              </span>
            </template>
            <ul v-if="sortMobile" class="modal-sort">
              <li v-for="(item, i) in listSort" :key="`sorts-${i}`" @click.stop="setSelected(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </template>
      </div>
      <template v-if="listTag.length && status.tag">
        <div v-if="!isScroll" class="search-filter__tag-title">
          <span class="title">{{ titleTag }}</span>
          <span v-if="tagBy.length" class="clear" @click="tagProductBy(null, true)">Clear</span>
        </div>
        <ul :class="{ scrolled: isScroll }" class="tabs search-filter__tag">
          <li v-if="isScroll && tagBy.length" style="margin: 10px 10px 0 0" @click="tagProductBy(null, true)">
            <SvgImg name="close-black-icon" width="12" height="12" />
          </li>
          <li v-for="(tag, idx) in listTag" :key="'list-tag-' + idx" class="tabs__item search-filter__tag__list">
            <a href="" :class="{ active: tagBy.indexOf(tag._id) > -1 }" @click.prevent="tagProductBy(tag)">{{
              tag.name
            }}</a>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import Api from '@/api/Api';
import { findFamilyOnNestedArray } from '@/shared/utils';

const api = new Api({ name: 'MS_CATALOG_API_URL' });
export default {
  name: 'list-sort-product',
  props: {
    listLeftMobile: {
      type: Array,
      required: false,
      default: () => [],
    },
    defaultSort: {
      type: String,
      required: false,
      default: '',
    },
    productCount: {
      type: Number,
      required: false,
      default: 0,
    },
    isLoadingFinish: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      status: {
        tag: false,
        sort: false,
      },
      title: {
        top: '',
        bottom: 0,
      },
      listSort: [
        { label: 'Terlaris', url: '-six_month_total_orders', value: 'most-purchased' },
        { label: 'Review', url: '-review_stats.total_reviews', value: 'most-review' },
        {
          label: 'Produk Terbaru - Terlama',
          url: 'newest',
          value: '-created_at',
        },
        {
          label: 'Produk Terlama - Terbaru',
          url: 'oldest',
          value: 'created_at',
        },
        {
          label: 'Harga Rendah - Tinggi',
          url: 'default_combination.price_after_discount',
          value: 'cheapest',
        },
        {
          label: 'Harga Tinggi - Rendah',
          url: '-default_combination.price_after_discount',
          value: 'expensive',
        },
        { label: 'A - Z', url: 'name', value: 'aToZ' },
        { label: 'Z - A', url: '-name', value: 'zToA' },
      ],
      sortBy: '',
      titleTag: '',
      tagLevel: '',
      parentList: '',
      tagBy: [],
      listTag: [],
      sortMobile: false,
      showDropDown: false,
      isScroll: false,
      isSelected: false,
      init: true,
      scrollTop: 0,
      bottom: 0,
      params: {
        sort: '',
        filter: {},
      },
    };
  },
  computed: {
    topTitle() {
      const route = this.$route;
      let title = '';
      if (route.name === 'BrandDetail' || route.name === 'BrandDetailOrigin') {
        if (this.$route.query.category_id) {
          const breadcrumbs = findFamilyOnNestedArray(
            this.listLeftMobile,
            '_id',
            route.query.category_id,
            'children',
            []
          );
          if (breadcrumbs.length) {
            title = breadcrumbs[breadcrumbs.length - 1].name;
          }
        }
      } else if (route.name === 'Category' || route.name === 'ProductMatchCategory') {
        const tags = [
          {
            category: 'skincare',
            tag: 'Concern',
            label: 'Pick your skin concern',
          },
          {
            category: 'hair care',
            tag: 'Skin/Hair Type',
            label: 'Pick your hair concern',
          },
        ];
        if (this.currentCategory && this.currentCategory.active) {
          const active = { ...this.currentCategory.active };
          title = active.name;

          if (tags.filter((x) => x.category === active.name.toLowerCase()).length) {
            title = 'All ' + active.name;
          }
        }
      } else if (route.name === 'Search' || route.name === 'TagConcern') {
        title = '';
      }

      return title;
    },
    currentCategory() {
      const category = this.$store.state.category;
      if (category) {
        return category;
      } else {
        return null;
      }
    },
    categories() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    screen() {
      return this.$store.state.screen;
    },
    sortName() {
      if (!this.sortBy) {
        return '';
      }
      const find = this.listSort.find((x) => x.url === this.sortBy) || {};
      return find.label || '';
    },
  },
  watch: {
    $route(to, from) {
      this.getStatus(from, to);
      this.setTitle(to);
    },
    // status: {
    //   handler(val) {
    //     if (val.tag === true) {
    //       this.getTag();
    //     }
    //   },
    //   deep: true,
    // },
    productCount: {
      handler(val) {
        if (!isNaN(val)) {
          this.title.bottom = val;
          this.$nextTick(() => {
            const sortby = document.getElementById('sticky_sortby_wrapper');
            const { top } = sortby.getBoundingClientRect();
            this.bottom = top - 60;
          });
        }
      },
      immediate: true,
    },
    isLoadingFinish: {
      handler(val, old) {
        if (old === false && val === true) {
          this.$nextTick(() => {
            const sortby = document.getElementById('sticky_sortby_wrapper');
            const { top } = sortby.getBoundingClientRect();
            this.bottom = top - 60;
          });
        }
        if (val) {
          this.init = false;
        }
      },
      immediate: true,
    },
    listLeftMobile: {
      handler(val) {
        this.setTitle(this.$route);
      },
      immediate: true,
    },
    sortBy(val) {
      console.log(val);
      this.$store.commit('$_URI/SET_QUERY_STRING', { name: 'sort', value: val });
      if (!this.init) {
        this.params.sort = val;
        this.$emit('filtered', { ...this.params });
      }
    },
    currentCategory: {
      deep: true,
      handler() {
        this.getStatus(null, this.$route);
      },
    },
    tagLevel: {
      deep: true,
      handler(tagLevel) {
        if (tagLevel) {
          this.getTag();
        }
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.stickySortBy);
    if (this.status.sort) {
      let valueSort = this.$route.query.sort ? this.$route.query.sort : this.$route.query.sortby;
      //if (this.$route.query.sortBy) valueSort = this.$route.query.sortBy
      if (valueSort) {
        const checkSort = this.listSort.filter((x) => x.url === valueSort);
        valueSort = checkSort.length ? checkSort[0].url : this.sortBy;
      } else {
        valueSort = this.defaultSort || this.sortBy;
      }
      if (valueSort !== this.sortBy) {
        this.sortBy = valueSort;
        this.params.sort = this.sortBy;
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.stickySortBy);
  },
  methods: {
    setTitle(route) {
      if (route.name === 'BrandDetail' || route.name === 'BrandDetailOrigin') {
        let title = 'All Products';
        if (this.$route.query.category_id) {
          const breadcrumbs = findFamilyOnNestedArray(
            this.listLeftMobile,
            '_id',
            route.query.category_id,
            'children',
            []
          );
          if (breadcrumbs.length) {
            title = breadcrumbs[breadcrumbs.length - 1].name;
          }
          this.isSelected = true;
          this.params.filter['category'] = {
            _id: this.$route.query.category_id,
          };
        }
        this.title.top = title;
      }
    },
    stickySortBy(e) {
      if (!this.screen.isDesktop) {
        try {
          const header = document.getElementById('main_header__v2');
          if (this.bottom > 0 && window.scrollY > this.bottom) {
            this.isScroll = true;
            this.scrollTop = header.offsetHeight;
          } else {
            this.isScroll = false;
            this.scrollTop = 0;
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.isScroll = false;
      }
    },
    showSort() {
      if (!this.screen.isDesktop) {
        this.sortMobile = !this.sortMobile;
        this.showDropDown = false;
      }
    },
    selectedList(data, level, index) {
      this.showDropDown = false;
      this.params.filter['category'] = data;
      this.$emit('filtered', { ...this.params });
    },
    setSelected(item) {
      if (item && item.url) {
        this.sortBy = item.url;
        this.sortMobile = false;
        this.params.sort = item.url;
      }
    },
    resetSort() {
      this.params.sort = '';
      this.sortBy = '';

      this.$store.commit('$_URI/SET_QUERY_STRING', {
        name: 'sort',
        value: '',
      });
    },
    resetFilter(e, key) {
      let reset = false;
      let reload = false;
      if (e && (e.target.localName === 'use' || e.target.localName === 'svg')) {
        (reset = true), (reload = true);
      }
      if (!e) {
        reset = true;
      }
      if (reset && this.params.filter && this.params.filter[key]) {
        this.showDropDown = false;
        if (reload) {
          this.params.filter[key] = { reload_category: true };
        } else {
          delete this.params.filter[key];
        }
        this.$emit('filtered', { ...this.params });
      }
    },
    getTag() {
      const params = {
        limit: 0,
        sort: 'created_at',
        filter: {
          level_name: this.tagLevel,
          is_filter: true,
        },
        fields: '_id name level_name',
      };
      api
        .getData({
          endpoint: '/tags',
          params,
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let list = response.data.data;
            if (this.tagLevel === 'Skin/Hair Type') {
              list = response.data.data.filter((x) => x.name.toLowerCase().includes('rambut'));
            }
            this.listTag = list;
          }
        })
        .catch((error) => {});
    },
    tagProductBy(tag, reset = false) {
      let isReset = reset;
      if (!reset) {
        const index = this.tagBy.indexOf(tag._id);
        if (index > -1) {
          this.tagBy.splice(index, 1);
        } else {
          this.tagBy.push(tag._id);
        }
        if (this.tagBy.length) {
          this.params.filter['tags'] = this.tagBy;
        } else {
          isReset = true;
        }
      }
      if (isReset) {
        this.tagBy.splice(0);
        this.resetFilter(null, 'tags');
      } else {
        this.$emit('filtered', { ...this.params });
      }
    },
    getStatus(from, to) {
      const tagRoutes = ['Category'];
      const sortRoutes = [
        'Category',
        'BrandDetail',
        'Search',
        'TagConcern',
        'BrandDetailOrigin',
        'ProductMatchCategory',
      ];

      this.tagLevel = '';
      this.titleTag = '';
      this.parentList = '';
      this.isSelected = false;

      let showTag = tagRoutes.includes(to.name);
      const showSort = sortRoutes.includes(to.name);

      if (this.$route.query.tags) {
        this.tagBy = this.$route.query.tags.split(',');
        this.params.filter['tags'] = this.tagBy;
      }

      if (to.name === 'Category' || to.name === 'ProductMatchCategory') {
        const tags = [
          {
            category: 'skincare',
            tag: 'Concern',
            label: 'Pick your skin concern',
          },
          {
            category: 'hair care',
            tag: 'Skin/Hair Type',
            label: 'Pick your hair concern',
          },
        ];
        if (this.currentCategory && this.currentCategory.active) {
          const active = { ...this.currentCategory.active };
          let title = active.name;
          if (to.name !== 'ProductMatchCategory') {
            let name = active.name;
            if (this.categories.length && active.parents.length) {
              const find = this.categories.filter((x) => active.parents.includes(x._id));
              name = find.length ? find[0].name : active.name;
            }
            this.parentList = 'All ' + name;
            const selectedTag = tags.find((x) => x.category === name.toLowerCase());
            if (selectedTag && selectedTag.tag) {
              this.tagLevel = selectedTag.tag;
              this.titleTag = selectedTag.label;
            }
            showTag = Boolean(selectedTag);
            if (tags.filter((x) => x.category === active.name.toLowerCase()).length) {
              title = 'All ' + active.name;
            } else {
              this.isSelected = true;
            }
          } else {
            this.listSort.push(
              {
                label: 'Product A - Z',
                value: 'name',
                url: 'name',
              },
              {
                label: 'Product Z - A',
                value: '-name',
                url: '-name',
              }
            );
          }
          this.title.top = title;
        }
      } else if (to.name === 'BrandDetail' || to.name === 'BrandDetailOrigin') {
        this.parentList = 'All Products';
        if (this.$route.query.category_id) {
          this.isSelected = true;
        }
      } else if (to.name === 'Search' || to.name === 'TagConcern') {
        this.title.top = 'Product';
        if (to.name === 'TagConcern') {
          this.title.top = 'All Products';
        }
        if (this.listSort[0].value !== 'relevan') {
          this.listSort.unshift({
            label: 'Relevan',
            value: 'relevan',
            url: 'relevan',
          });
        }
      }

      this.status.tag = showTag;
      this.status.sort = showSort;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tabs__item {
  border: none !important;
}
.pb-0 {
  padding-bottom: 0px !important;
}
.search-filter {
  &__tabs {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    position: relative;
    overflow-y: initial;
    overflow-x: initial;
    .title {
      margin: 0;
      line-height: normal;
      &__name {
        font-size: 16px;
        color: #222222;
        font-family: 'lato-regular', sans-serif;
      }
      &__count {
        font-size: 11px;
        color: #8c8582;
        font-family: 'lato-regular', sans-serif;
      }
    }
    .right-content {
      position: absolute;
      right: 0;
      top: -16px;
      @media (max-width: 768px) {
        position: static;
      }
      span {
        font-size: 12px;
        color: #8c8582;
        letter-spacing: normal;
        line-height: 15px;
        margin-right: 12px;
        font-family: 'lato-regular', sans-serif;
      }
      select {
        width: 125px;
      }
    }
  }
  &__tag-title {
    border-top: 1px solid #e5e5e5;
    padding: 16px 0 8px;
    font-size: 14px;
    letter-spacing: 0;
    display: flex;
    justify-content: space-between;
    span.title {
      color: #8c8582;
      font-family: 'lato-regular', sans-serif;
    }
    span.clear {
      color: #eb395f;
      cursor: pointer;
      font-family: 'lato-regular', sans-serif;
    }
  }
  &__tag {
    overflow-x: hidden;
    position: relative;
    display: block;
    &__list {
      display: inline-block !important;
      margin: 8px 8px 0 0;
      a {
        border: 1px solid #ffd3d3;
        border-radius: 29.5px;
        font-family: 'lato-regular', sans-serif;
        font-size: 13px;
        color: #222222 !important;
        &.active {
          background-color: #f384a7;
          border: none;
          color: #ffffff !important;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .search-filter {
    &__tabs {
      position: unset !important;
      .right-content {
        span {
          vertical-align: middle;
          margin-left: 6px;
          font-size: 12px;
          color: #eb395f;
          cursor: pointer;
          letter-spacing: 0px;
          font-family: 'lato-regular', sans-serif;
        }
        .sort-reset {
          margin-left: 0px;
          vertical-align: bottom;
        }
      }
      &.scrolled {
        display: unset;
        justify-content: unset;
      }
      &:before,
      &:after {
        display: none;
      }
    }
    &__tag {
      position: unset !important;
      display: flex;
      overflow-x: auto;
      &__list {
        a {
          font-size: 12px;
          padding: 5px 12px;
        }
      }
      &.scrolled {
        padding: 6px 0 0 10px;
      }
    }
    .sort-sticky-title {
      padding: 0 16px 12px;
      margin: 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      .sort-sticky-title__left {
        text-align: center;
        border-right: 1px solid #e5e5e5;
        width: 50%;
      }
      .sort-sticky-title__right {
        width: 50%;
        text-align: center;
      }
      .sort-sticky-title__name,
      .sort-sticky-title__sort-name {
        color: #eb395f;
        font-size: 13px;
        text-transform: capitalize;
      }
      .sort-reset {
        margin-left: 8px;
      }
      .sort-sticky-title__popup {
        font-size: 13px;
        letter-spacing: normal;
        color: #231f20;
        list-style: none;
        margin: 12px 0 0;
        padding: 20px 16px;
        text-align: left;
        background: #ffffff;
        position: absolute;
        left: 0;
        max-height: calc(100vh - 250px);
        width: 100%;
        overflow-y: auto;
        box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.3);
        border-radius: 0 0 4px 4px;

        &::-webkit-scrollbar {
          width: 7px;
          -webkit-appearance: none;
        }

        &::-webkit-scrollbar-track {
          background: #e5e5e5;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #e5e5e5;
          border: 7px solid #8c8582;
        }

        li.parent_name__ {
          padding-bottom: 20px;
          text-transform: uppercase;
          font: 12px/16px $lato_bold;
          letter-spacing: normal;
          ul.child_name__ {
            list-style: none;
            padding: 0;
            margin: 0;
            & > li {
              padding-bottom: 20px;
              span {
                font: 14px/17px $lato_regular;
                text-transform: capitalize;
              }
            }
            & > li:last-child {
              padding-bottom: 0;
            }
            & > li:first-child {
              padding-top: 20px;
            }
          }
        }
        li:first-child {
          padding-bottom: 20px;
          font: 12px/16px $lato_bold;
          text-transform: uppercase;
        }
        li:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
  .modal-sort {
    list-style: none;
    position: absolute;
    right: 0;
    z-index: 999;
    background: #ffffff;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.3);
    border-radius: 0 0 4px 4px;
    font-size: 14px;
    color: #231f20;
    width: 65%;
    margin: 13px 0 0;
    padding: 10px 0;
    text-align: left;
    li {
      padding: 10px 16px;
    }
  }
  #sticky_sortby.sticky {
    position: fixed;
    top: 92px;
    width: 100%;
    background: #ffffff;
    z-index: 999;
    padding: 12px 0;
    left: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  }
  .no-tag {
    border: none !important;
    padding-bottom: 0 !important;
  }
}
</style>
